import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { CategoriesComponent } from './categories/categories.component';
//import { NalgenesComponent } from './nalgenes/nalgenes.component';
import { CategoryService } from './categories/category.service';
import { ProductsService } from './categories/nalgenes/products.service';
import { CertificationsPipe } from './categories/certifications.pipe';
import { BooleanPipe } from './categories/boolean.pipe';
import { RatingPipe } from './categories/rating.pipe';

@NgModule({
  declarations: [
    AppComponent,
    CategoriesComponent,
    CertificationsPipe, BooleanPipe, RatingPipe

  ],
  imports: [
    BrowserModule, HttpModule, FormsModule
  ],
  providers: [CategoryService, ProductsService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/thomas.obrien2/projects/nalgene/src/app/app.module.ts